import FinanceApi from '@/services/apiService';

/*
  for import conciliable mixins, is necessary import mixin in the component and add into mixins
  attribute.

  for use filtered data is necessary declare the next data in the component:

  return filtered data for country attribute.
    this.search.country (optional)
    this.defaultCountry (optional)
*/

export default {
  data() {
    return {
      BBconciliables: [],
    };
  },
  beforeMount() {
    this.fetchBBConciliables();
  },
  methods: {
    fetchBBConciliables() {
      FinanceApi.getBBConciliables().then((data) => {
        this.BBconciliables = data.body;
      });
    },
    filterBBConciliables(country) {
      return this.BBconciliables.filter((conciliable) => conciliable.country === country)
        .map((conciliable) => (this.formatBBConciliable(conciliable)));
    },
    formatBBConciliable(conciliable) {
      return {
        key: conciliable.name,
        value: conciliable.name,
        id: conciliable.id,
        klass: conciliable.klass,
        idKey: `${conciliable.id}-${conciliable.klass}`,
      };
    },
    getBBConciliable(idKey) {
      return this.filteredBBConciliables.find((conciliable) => conciliable.idKey === idKey);
    },
  },
  computed: {
    filteredBBConciliables() {
      const country = this.search.country || this.defaultCountry;
      let filteredBBConciliables = this.BBconciliables;

      if (country) {
        filteredBBConciliables = filteredBBConciliables
          .filter((conciliable) => conciliable.country === country);
      }

      return filteredBBConciliables.map((conciliable) => (this.formatBBConciliable(conciliable)));
    },
  },
};
